var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_613_9",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H0V20H19V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_613_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.457 2.49987C13.665 2.28107 13.9118 2.10737 14.1835 1.98897C14.4552 1.87047 14.7464 1.80957 15.0404 1.80957C15.3344 1.80957 15.6256 1.87047 15.8973 1.98897C16.1689 2.10737 16.4158 2.28107 16.6237 2.49987C16.8316 2.71877 16.9965 2.97857 17.1091 3.26457C17.2216 3.55057 17.2795 3.85707 17.2795 4.16657C17.2795 4.47607 17.2216 4.78257 17.1091 5.06857C16.9965 5.35457 16.8316 5.61437 16.6237 5.83327L5.93617 17.0833L1.58203 18.3333L2.76953 13.7499L13.457 2.49987Z",
    stroke: "#44BCFF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4e94c4c5a4b7bd6c6ee92ddf8e6545c1.svg";
export { ForwardRef as ReactComponent };